import React from "react";
import FulfilledList from "../../components/fullfillment/fullfillmentList";

export const Returned = () => {
  return (
<FulfilledList status={'returned'} listTitle='RETURNED MAIL'/>
  );
};

export default Returned;